module.exports = __webpack_public_path__ + "static/media/comment-outline.c8344a49.svg";